/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { getDefaultScorecardState } from './scorecard';
import { AnyAction } from 'redux';
import { ScorecardKeys, ScorecardState } from '../types/scorecard';

const scorecardSurvey = (state = getDefaultScorecardState(), action: AnyAction): ScorecardState => {
  const lastUpdated = Date.now();
  const type: ScorecardKeys = action.tag || 'main';
  switch (action.type) {

    case actionTypes.LOADING_SCORECARD_SURVEY:
      // Reset state on surveyId change
      if (state.surveyId !== action.surveyId) {
        return {
          ...getDefaultScorecardState(),
          [type]: { ...state[type], data: {}, loaded: false, loading: true },
          surveyId: action.surveyId,
          tag: action.tag,
          lastUpdated,
        }
      }
      return {
        ...state,
        [type]: { ...state[type], data: {}, loaded: false, loading: true },
        data: undefined,
        surveyId: action.surveyId,
        tag: action.tag,
        loaded: false,
        errored: false,
        lastUpdated,
      };
    case actionTypes.ERROR_SCORECARD_SURVEY:
      return {
        ...state,
        tag: action.tag,
        loaded: false,
        errored: true,
        lastUpdated,
        errorMessage: action.errorMessage
      };
    case actionTypes.LOADED_SCORECARD_SURVEY:
      const { scorecard, initiative } = action.data;
      return {
        ...state,
        [type]: {
          ...state[type],
          data: {
            scorecard: { ...scorecard, initiativeName: initiative.name },
            initiativeName: initiative.name,
            initiative
          },
          loaded: true,
          loading: false,
        },
        loaded: true,
        errored: false,
        lastUpdated
      };
    default:
      return state;
  }
};

export default scorecardSurvey;
